<header app-header></header>
<nav app-nav class="navbar navbar-expand-lg"></nav>

<section class="container">
  <router-outlet></router-outlet>
</section>

<footer app-footer class="border-top ps-3"></footer>
